import { connect } from "knockout-store";
import menuJS from "./menu";
import { refresh } from "../storyline/storyline";
import { getMobileIndex } from "../../utils/functions";
import { t } from "../../utils/translations";

function indexViewmodel(params) {
  const vm = {};

  params.storylineData.subscribe(() => {
    menuJS();
  });

  vm.data = () => params.storylineData;
  vm.translation = (key) => t(key);
  vm.isVisible = () => "index" === params.modal();
  vm.isActivePart = (id) => params.currentPartID() === id;
  vm.isActiveChapter = (id) => params.currentChapterID() === id;
  vm.goTo = (partID, chapterID, paragraphID, event, toTop) => {
    if (toTop) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    }

    event.preventDefault();
    params.modal("");

    // track current chapter for desktop
    if (params.isMobile() === false) {
      params.currentChapterID(chapterID);
    }

    if (chapterID) params.currentChapterID(chapterID);
    params.currentPartID(partID);
    refresh(partID, chapterID);

    // slide to correct part on mobile
    if (params.isMobile()) {
      params.mobileSlidesPosition(
        getMobileIndex(params.mobileSlides(), chapterID)
      );
    }
  };

  return vm;
}

function mapStateToParams({
  modal,
  route,
  storylineData,
  currentPartID,
  currentChapterID,
  mobileSlides,
  mobileSlidesPosition,
  isMobile,
}) {
  return {
    modal,
    route,
    storylineData,
    currentPartID,
    currentChapterID,
    mobileSlides,
    mobileSlidesPosition,
    isMobile,
  };
}

export default connect(mapStateToParams)(indexViewmodel);
